export default __webpack_public_path__ + "static/media/ER2_activations_XY.1f59ebf3.png";